var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 12.453V1.297A.794.794 0 0 0 14.578.5H3.688A3.189 3.189 0 0 0 .5 3.688v10.624A3.189 3.189 0 0 0 3.688 17.5h10.89a.794.794 0 0 0 .797-.797v-.53a.803.803 0 0 0-.295-.62 7.41 7.41 0 0 1 0-2.482.793.793 0 0 0 .295-.618zM4.75 4.95a.2.2 0 0 1 .2-.199h7.042a.2.2 0 0 1 .2.2v.663a.2.2 0 0 1-.2.2H4.949a.2.2 0 0 1-.199-.2V4.95zm0 2.125a.2.2 0 0 1 .2-.199h7.042a.2.2 0 0 1 .2.2v.663a.2.2 0 0 1-.2.2H4.949a.2.2 0 0 1-.199-.2v-.664zm8.414 8.301H3.692a1.062 1.062 0 1 1 0-2.125h9.472a11.95 11.95 0 0 0 0 2.125z",
    fill: "#697482"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.031ba96ccd54685bc7f64d0c30ce18b0.svg";
export { ForwardRef as ReactComponent };